import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@/services/sentry';
import { initWebVitals } from '@/utils/web-vitals';
import { App } from '@/app';
import '@/styles/globals.css';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

initWebVitals();
